import script from "./PatientVisitServiceTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientVisitServiceTableRow.vue?vue&type=script&setup=true&lang=js"

import "./PatientVisitServiceTableRow.vue?vue&type=style&index=0&id=13132c6d&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13132c6d"]])

export default __exports__